import findIndex from "lodash/findIndex";

export default function(list, object, comparator) {
    const index = findIndex(list, comparator);
    if (index > -1) {
        list.splice(index, 1, object);
    } else {
        list.push(object);
    }
    return list;
}
